import {
  useCartContext
} from "@/context/cart"
import {
  gql,
  useQuery
} from "@apollo/client"

export const CartTriggerFragment = gql`
    fragment CartTriggerFragment on Cart {
        id
        total_quantity
    }
`
export const GET_ITEM_COUNT_QUERY = gql`
    query getItemCount($cartId: String!) {
        cart(cart_id: $cartId) {
            id
            ...CartTriggerFragment
        }
    }
    ${CartTriggerFragment}
`

export const useItemCount = () => {
  const [{
    cartId 
  }] = useCartContext()
  const {
    data 
  } = useQuery(GET_ITEM_COUNT_QUERY, {
    fetchPolicy: "cache-and-network",
    variables: {
      cartId,
    },
    skip: !cartId,
    errorPolicy: "all",
  })

  const itemCount = data?.cart?.total_quantity || 0

  return {
    itemCount
  }
}
